import React from 'react';
import { Button } from '@mantine/core';
import { IconDeviceFloppy, IconX } from '@tabler/icons-react';
import { confirmAbandon } from '../lib/formAbandon';

export function CancelButton({
  children = 'Annuler',
  confirmIfDirty = false,
  isDirty = false,
  onClick,
  ...props
}) {
  const handleClick = async (event) => {
    if (confirmIfDirty && !(await confirmAbandon(isDirty))) return;
    onClick?.(event);
  };

  return (
    <Button type="button" variant="default" leftSection={<IconX size={16} />} onClick={handleClick} {...props}>
      {children}
    </Button>
  );
}

export function SaveButton({ children = 'Enregistrer', ...props }) {
  return (
    <Button type="submit" leftSection={<IconDeviceFloppy size={16} />} {...props}>
      {children}
    </Button>
  );
}
